import React from "react";
import { CloudUpload } from "@material-ui/icons";
import locale from "@bonliva-crm/locale";
import {
  useGetCustomerContractFilesQuery,
  GetCustomerContractFiles,
  GetCustomerContractEventLog,
  useDeleteCustomerContractDocMutation
} from "@graphql";
import { SecondaryButton } from "@components";
import DocumentList from "@containers/DocumentList/DocumentList";

type Props = {
  customerContractId: string;
  onUpload: () => void;
};

export function CustomerContractDocuments(props: Props) {
  const { data, loading } = useGetCustomerContractFilesQuery({
    variables: {
      customerContractId: props.customerContractId
    }
  });
  const [deleteDoc] = useDeleteCustomerContractDocMutation();
  const handleDelete = (doc) => {
    deleteDoc({
      variables: {
        customerContractId: data.customerContractById._id,
        fileId: doc.FileRef.NodeID
      },
      refetchQueries: [
        GetCustomerContractFiles.OperationName,
        GetCustomerContractEventLog.OperationName
      ]
    });
  };

  return (
    <div>
      <div style={{ display: "flex", marginBottom: 16 }}>
        <SecondaryButton
          onClick={props.onUpload}
          variant="outlined"
          leftIcon={<CloudUpload />}
          style={{ marginLeft: "auto" }}
        >
          {locale.UploadFile}
        </SecondaryButton>
      </div>

      <DocumentList
        loading={loading}
        groupBy={(d) => locale.customerContractDocumentTypes[d.DocumentType]}
        documents={data?.customerContractById.attachments || []}
        onDelete={handleDelete}
      />
    </div>
  );
}
